<template>
    <header>
        <div class="container">
            <div class="row">
            <div class="col-12 my-4">
                <h1 class="puzzle-title">Escolha um quebra-cabeça</h1>
            </div>
            </div>
        </div>
    </header>
</template>

<style scoped>

header {
  background: #ffd40c;
}

</style>